import { DialogComponent } from '@theme/dialog';

/**
 * A custom element that manages the PDP size guide (bottom sheet on mobile, centred modal on desktop).
 * Open/close, Escape, backdrop click, scroll lock and focus return are handled by DialogComponent.
 * Content only - this component never touches cart state.
 *
 * @extends {DialogComponent}
 */
class SizeGuideDrawer extends DialogComponent {
  showDialog() {
    super.showDialog();

    // Move focus to the dialog itself rather than the close button. Focusing the button programmatically
    // draws a focus ring on touch devices; keyboard users still reach the button (with its ring) via Tab.
    this.refs.dialog.focus({ preventScroll: true });
  }

  /**
   * Switches the measurement unit. Both units are already in the markup; CSS shows the one matching data-unit,
   * so this only flips the attribute and the pressed state of the buttons. No arithmetic happens here.
   *
   * @param {Event} event - The click event, targeting the unit button.
   */
  setUnit(event) {
    const { target } = event;
    if (!(target instanceof HTMLElement)) return;

    const unit = target.dataset.unitOption;
    if (unit !== 'cm' && unit !== 'in') return;

    this.dataset.unit = unit;

    for (const button of this.querySelectorAll('[data-unit-option]')) {
      button.setAttribute('aria-pressed', String(button instanceof HTMLElement && button.dataset.unitOption === unit));
    }
  }
}

if (!customElements.get('size-guide-drawer')) {
  customElements.define('size-guide-drawer', SizeGuideDrawer);
}
